var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLossLimit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 20.5a.75.75 0 010 1.5H2.75a.75.75 0 010-1.5h18.5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2a1 1 0 011 1v8c0 .138.112.25.25.25h1.967c.937 0 1.359 1.175.636 1.771l-7.216 5.954-.072.053a1 1 0 01-1.202-.053L4.147 13.02c-.723-.596-.301-1.77.636-1.771H6.75A.25.25 0 007 11V3a1 1 0 011-1h8zm-7.5 9a1.75 1.75 0 01-1.75 1.75h-.575L12 17.556l5.825-4.806h-.575A1.75 1.75 0 0115.5 11V3.5h-7V11z",
    fill: "currentColor"
  })));
}
SvgLossLimit.displayName = 'LossLimit';
export default SvgLossLimit;